// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-msg[data-v-be4d803e]{font-family:\"Inter\",InterFallback,serif;font-weight:400;letter-spacing:.1px;line-height:17px;font-size:12px;position:absolute;margin-top:4px;height:20px;color:#ff5564;font-weight:500}@media (max-width:1023px){.error-msg[data-v-be4d803e]{line-height:15px;font-size:11px}}.error-msg--bold[data-v-be4d803e]{font-weight:700}.error-msg .handler[data-v-be4d803e]{font-weight:700;color:#a363ff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
